import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from '../store';
import Logo from './Logo';
import MainNavigation from './MainNavigation';
import Painting from './Painting';
import VirtualHelp from './VirtualHelp';
import VirtualInfo from './VirtualInfo';
import { initLayoutState1, LayoutMaxWidth, LayoutState, MediaQueryFixMargin, MediaQueryMobile, MediaQueryScaleMargin, MediaQueryShallow, MediaQuerySmall1, MediaQuerySmall2, MediaQuerySmall3, MediaQuerySmall4, MediaQuerySmall5 } from '../Layout';
import SiteVirtualTour from './SiteVirtualTour';
import SiteMobile from './SiteMobile';

export default function SiteDesktop(params: {layoutState: LayoutState}) {
    const nav = useSelector((state: RootState) => state.navigation.value);

    const marginLeft = params.layoutState.marginLeft();
    const wPano = params.layoutState.WidthPano();
    const hPano = params.layoutState.HeightPano();

    return (
        <Box sx={{ minHeight: "100vH", bgcolor: "kr.main" }}>
            <Logo />
            <Box sx={{ marginLeft: marginLeft, maxWidth: LayoutMaxWidth }}>
                <MainNavigation />
                <SiteVirtualTour nav={nav} />

                <div id="krpano-kr" style={{ width: wPano, height: hPano, display: "none", paddingTop: params.layoutState.LayoutPanoPaddingTop() }}></div>
            </Box>
            <Box sx={{ marginLeft: marginLeft, maxWidth: LayoutMaxWidth }}>
                <Outlet></Outlet>
            </Box>
        </Box>
    );

}